<vb-breadcrumb-one
    [title]="article?.title || 'Article'"
    [parents]="newsParent"
    [disableTitle]="true"></vb-breadcrumb-one>

<div class="news-page">
    <div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--page">
        <vb-spinner size="xl" label="Loading article"></vb-spinner>
    </div>

    <ng-container *ngIf="!isLoading && !isFailed">
        <vb-news-article
            [article]="article"
            [showBack]="false"
            [showFooter]="false">
        </vb-news-article>

        <nav
            *ngIf="neighbours?.previous || neighbours?.next"
            class="news-page__neighbours"
            [attr.aria-label]="'newsArticle.navigation' | translate">
            <a
                *ngIf="neighbours?.previous as previous"
                class="news-page__neighbour"
                [routerLink]="['/news', previous.id]">
                <span class="news-page__neighbour-label">
                    <span aria-hidden="true">←</span>
                    {{ 'newsArticle.previous' | translate }}
                </span>
                <span class="news-page__neighbour-title">{{
                    previous.title
                }}</span>
            </a>
            <a
                *ngIf="neighbours?.next as next"
                class="news-page__neighbour news-page__neighbour--next"
                [routerLink]="['/news', next.id]">
                <span class="news-page__neighbour-label">
                    {{ 'newsArticle.next' | translate }}
                    <span aria-hidden="true">→</span>
                </span>
                <span class="news-page__neighbour-title">{{ next.title }}</span>
            </a>
        </nav>
    </ng-container>

    <div *ngIf="isFailed && !isLoading" class="news-page__fallback">
        <h1 class="news-page__title">News</h1>
        <p class="news-page__message">Failed to load article</p>
    </div>
</div>
